/**
 * A aprovação do pedido de Terraform no cartão da conversa (consoleai#25973).
 *
 * No PRD do BackOfficePOS o pedido ficou esperando aprovação e o único lugar
 * para decidir era o chamado: quem pediu não via quem decide, e quem decide não
 * via onde. Reusa `DecisaoDoPedido` (a mesma do chamado e da tela de WAF);
 * quem decide se o botão aparece segue sendo o servidor (`aprovacao.pode_aprovar`).
 * A aprovação só monta com `aprovacao`: fora de `aguardando_aprovacao` não há o
 * que mostrar.
 *
 * O pedido parado que o servidor deixa completar (`pode_completar`) ganha aqui
 * o mesmo botão do chamado (`CompletarDoPedido`): no ajuste livre em
 * `apply_parcial`, "Reaplicar a partir da master" (consoleai#26379) — o #95 do
 * bshub/hml só tinha saída por um apply fora do runner.
 */
import { useQueryClient } from '@tanstack/react-query'
import type { PedidoDoCartao } from '@/api/terraformRunner'
import { CompletarDoPedido } from '@/components/chamados/CompletarDoPedido'
import { DecisaoDoPedido } from '@/components/chamados/DecisaoDoPedido'
import { CHAVE_PEDIDO_TERRAFORM } from '@/hooks/useTerraformChangeRequest'

function Decisao({ pedido }: { pedido: PedidoDoCartao }) {
  const qc = useQueryClient()
  return (
    <DecisaoDoPedido pedido={pedido}
                     onDecidido={() => void qc.invalidateQueries({
                       queryKey: [CHAVE_PEDIDO_TERRAFORM] })} />
  )
}

function Completar({ pedido }: { pedido: PedidoDoCartao }) {
  const qc = useQueryClient()
  return (
    <CompletarDoPedido pedido={pedido}
                       onFeito={() => void qc.invalidateQueries({
                         queryKey: [CHAVE_PEDIDO_TERRAFORM] })} />
  )
}

export function DecisaoNoCartao({ pedido }: { pedido: PedidoDoCartao }) {
  return (
    <>
      {pedido.aprovacao ? <Decisao pedido={pedido} /> : null}
      {pedido.pode_completar ? <Completar pedido={pedido} /> : null}
    </>
  )
}
